import LeftSideBarConst from './../../components/LeftSideBar/const';

const Const = {
    CUSTOMERS_START_FETCH_REQUEST: 'CUSTOMERS_START_FETCH_REQUEST',
    CUSTOMERS_FETCH_REQUEST: 'CUSTOMERS_FETCH_REQUEST',
    [LeftSideBarConst.LEFT_SIDE_BAR_IS_FOLDED_OPEN]: LeftSideBarConst.LEFT_SIDE_BAR_IS_FOLDED_OPEN
};

export default Const;